import {Box, Container} from "@mui/material";
import {styled} from "@mui/system";
import PropTypes from "prop-types";
import React from "react";
import {HABILITA_CABECALHO} from "../../../shared/env";
import Header, {ALTURA_CABECALHO} from "../../header/Header";
import ModoAplicacao from "../../header/ModoAplicacao";
import IdentificacaoSessao from "../../header/IdentificacaoSessao";

const habilitaCabecalho = HABILITA_CABECALHO === "S";

const Root = styled("div")({
    display: "flex",
    minWidth: 0,
    overflowX: "hidden",
    width: "100%"
});

const Main = styled("main")(({theme}) => ({
    boxSizing: "border-box",
    flexGrow: 1,
    maxWidth: "100%",
    minWidth: 0,
    width: "100%",
    padding: habilitaCabecalho ? theme.spacing(0, 2, 12, 2) : 0
}));

function Page({children, maxWidth = "lg"}) {
    return (
        <Root>
            {habilitaCabecalho && <Header maxWidth={maxWidth} />}
            <Main>
                {habilitaCabecalho && (
                    <Box
                        sx={{
                            height: ALTURA_CABECALHO,
                            "@media print": {display: "none"}
                        }}
                    />
                )}
                <Container
                    maxWidth={maxWidth}
                    disableGutters={!habilitaCabecalho}
                >
                    {!habilitaCabecalho && (
                        <>
                            <IdentificacaoSessao showEnvironment={false} />
                            <ModoAplicacao />
                        </>
                    )}
                    {children}
                </Container>
            </Main>
        </Root>
    );
}

Page.propTypes = {
    SidebarComponent: PropTypes.func,
    children: PropTypes.node.isRequired,
    maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default Page;
